module.exports = __webpack_public_path__ + "media/content-creator/mobile-fashion-1-5c5efe67.png";